import styled from 'styled-components'

import { fromMd, untilMd } from '@syconium/little-miss-figgy'

export const HeaderWrapper = styled.header`
  align-items: center;
  display: flex;
  justify-content: space-between;

  ${untilMd} {
    background-color: white;
    border-bottom: 1px solid ${o => o.theme.color.deprecated.stone};
    height: 50px;
    margin: 0 -14px;
    padding: 0 14px;
    position: sticky;
    top: 0;
    z-index: 1;
  }
`

export const HeaderItem = styled.div<{ isVisible?: boolean }>`
  flex: 1;
  white-space: nowrap;
  visibility: ${props => (props.isVisible === false ? 'hidden' : 'inherit')};

  &:last-child {
    text-align: end;
  }
`

export const Title = styled.h1`
  color: ${o => o.theme.color.deprecated.obsidian};
  font-size: 20px;
  font-weight: 700;
  letter-spacing: 1.5px;
  margin-top: 36px;
  text-align: center;

  ${fromMd} {
    font-size: 36px;
    margin-top: 0;
  }
`
